import { vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "input-group" };
const _hoisted_2 = ["id", "placeholder", "type", "readonly", "autocomplete", "maxlength"];
const _hoisted_3 = ["id", "placeholder", "type", "readonly", "autocomplete", "maxlength"];
const _hoisted_4 = {
    key: 2,
    class: "input-group-text"
};
const _hoisted_5 = {
    key: 3,
    class: "input-group-text"
};
const _hoisted_6 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createElementVNode("div", _hoisted_1, [
                (!_ctx.updateLazy)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
                        key: 0,
                        class: ['form-control', _ctx.isInvalid ? 'is-invalid' : ''],
                        id: identification,
                        placeholder: _ctx.placeholder,
                        type: _ctx.modeInternal,
                        readonly: _ctx.readOnly,
                        autocomplete: _ctx.autocomplete,
                        maxlength: _ctx.maxLength === 0 ? '' : _ctx.maxLength,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event))
                    }, _ctx.inputAttrInternal, {
                        onBlur: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
                        onKeyup: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.onEnterKey && _ctx.onEnterKey(...args)))
                    }), null, 16, _hoisted_2)), [
                        [_vModelDynamic, _ctx.internalValue]
                    ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
                        key: 1,
                        class: ['form-control', _ctx.isInvalid ? 'is-invalid' : ''],
                        id: identification,
                        placeholder: _ctx.placeholder,
                        type: _ctx.modeInternal,
                        readonly: _ctx.readOnly,
                        autocomplete: _ctx.autocomplete,
                        maxlength: _ctx.maxLength === 0 ? '' : _ctx.maxLength,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.internalValue) = $event))
                    }, _ctx.inputAttrInternal, {
                        onBlur: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
                        onKeyup: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => (_ctx.onEnterKey && _ctx.onEnterKey(...args)))
                    }), null, 16, _hoisted_3)), [
                        [
                            _vModelDynamic,
                            _ctx.internalValue,
                            void 0,
                            { lazy: true }
                        ]
                    ]),
                (_ctx.mode === 'email')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createVNode(_component_g_icon, { src: _ctx.emailButtonIcon }, null, 8, ["src"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.mode === 'phone')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        _createVNode(_component_g_icon, { src: _ctx.phoneButtonIcon }, null, 8, ["src"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.mode === 'password')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        class: "input-group-text",
                        type: "button",
                        title: _ctx.$t('account.Password.Show'),
                        tabindex: "-1",
                        onClick: _cache[6] || (_cache[6] =
                            //@ts-ignore
                            (...args) => (_ctx.tooglePassword && _ctx.tooglePassword(...args)))
                    }, [
                        _createVNode(_component_g_icon, { src: _ctx.passwortButtonIcon }, null, 8, ["src"])
                    ], 8, _hoisted_6))
                    : _createCommentVNode("", true)
            ])
        ]),
        _: 1
    }, 16, ["name", "error-message", "label"]));
}
